import router from "../router";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import LanguageService from "@/services/language.service";
import _ from "lodash/index";
import i18n from "@/locale/i18n";

let baseUrl = 'http://localhost:8080/upload/'
if(import.meta.env.MODE === 'local')
  baseUrl = 'http://localhost:8080/upload/'
else if(import.meta.env.MODE === 'test')
  baseUrl = 'https://api.impactus2.co.kr/upload/'
else if(import.meta.env.MODE === 'prod')
  baseUrl = 'https://api.impactus.co.kr/upload/'

const utils = {
  movePage(path) {
    router.push({ path: path })
  },
  movePageQuery(path, query) {
    router.push({ path: path, query:query })
  },
  log(log){
    if(import.meta.env.MODE != 'production')
      console.log(log)
  },
  isEmpty(text){
    if(!text || text==='undefined' || text==='null' || text=='' || text===undefined || text===null)
      return true
    else
      return false
  },
  getBaseUrl(category, filePath){
    // http://localhost:8080/upload/editor/a20958e9-dce9-460e-9752-aa03fef9aae4.PNG
    return baseUrl+category+'/'+filePath
  },
  getBaseDateUrl(category, companyIdx, day, filePath){
    // http://localhost:8080/upload/editor/37/2025-08-02/a20958e9-dce9-460e-9752-aa03fef9aae4.PNG
    return baseUrl+category+'/'+companyIdx+'/'+day+'/'+filePath
  },
  isMobile(){
    const userAgent = navigator.userAgent.toLowerCase();
    return /android|iphone|ipad|ipod/.test(userAgent);
  },
  renameKeys(mapping, objArr){
    const renamedObjArr = []
    for (const obj of objArr) {
      const renamedObj = {}
      for (const [before, after] of Object.entries(mapping)) {
        if (obj.hasOwnProperty(before.replace(/\s+/g, ''))) {
          renamedObj[after] = obj[before.replace(/\s+/g, '')]
        }
      }
      renamedObjArr.push(renamedObj)
    }
    return renamedObjArr
  },
  changeLogLanguage(obj){
    console.log('current locale:', i18n.global.locale.value);
    console.log('messages for current locale:', i18n.global.getLocaleMessage(i18n.global.locale.value));

    //obj = obj.replace(/ /g, i18n.global.t(''));
    //공통
    obj = obj.replace(/useYn/g, i18n.global.t('message.useYn'));
    obj = obj.replace(/delYn/g, i18n.global.t('message.delYn'));

    //회사정보
    obj = obj.replace(/update dept/g, i18n.global.t('message.department')+i18n.global.t('message.update'));
    obj = obj.replace(/update pos/g, i18n.global.t('message.position')+i18n.global.t('message.update'));
    obj = obj.replace(/update shift/g, i18n.global.t('message.shiftWork')+i18n.global.t('message.update'));
    obj = obj.replace(/delete dept/g, i18n.global.t('message.department')+i18n.global.t('message.delete'));
    obj = obj.replace(/delete pos/g, i18n.global.t('message.position')+i18n.global.t('message.delete'));
    obj = obj.replace(/delete shift/g, i18n.global.t('message.shiftWork')+i18n.global.t('message.delete'));
    obj = obj.replace(/moduleCalender/g, i18n.global.t('message.moduleCalender'));
    obj = obj.replace(/moduleBbs/g, i18n.global.t('message.moduleBbs'));
    obj = obj.replace(/moduleLeadership/g, i18n.global.t('message.moduleLeadership'));
    obj = obj.replace(/moduleReport/g, i18n.global.t('message.moduleReport'));
    obj = obj.replace(/moduleBoard/g, i18n.global.t('message.moduleBoard'));
    //회원정보
    obj = obj.replace(/memberName/g, i18n.global.t('message.memberName'));
    obj = obj.replace(/clientIdx/g, i18n.global.t('message.clientIdx'));
    obj = obj.replace(/companyIdx/g, i18n.global.t('message.companyIdx'));
    obj = obj.replace(/email/g, i18n.global.t('message.email'));
    obj = obj.replace(/password/g, i18n.global.t('message.password'));
    obj = obj.replace(/posIdx/g, i18n.global.t('message.posIdx'));
    obj = obj.replace(/deptIdx/g, i18n.global.t('message.deptIdx'));
    obj = obj.replace(/telNo/g, i18n.global.t('message.telNo'));
    obj = obj.replace(/adminYn/g, i18n.global.t('message.adminYn'));
    obj = obj.replace(/headYn/g, i18n.global.t('message.headYn'));
    obj = obj.replace(/shiftYn/g, i18n.global.t('message.shiftYn'));
    obj = obj.replace(/shiftIdx/g, i18n.global.t('message.shiftIdx'));
    obj = obj.replace(/passwordYn/g, i18n.global.t('message.passwordYn'));
    //관리자정보
    obj = obj.replace(/authCompany/g, i18n.global.t('message.authCompany'));
    obj = obj.replace(/authMember/g, i18n.global.t('message.authMember'));
    obj = obj.replace(/authAdmin/g, i18n.global.t('message.authAdmin'));
    obj = obj.replace(/authBoard/g, i18n.global.t('message.authBoard'));
    obj = obj.replace(/authBbs/g, i18n.global.t('message.authBbs'));
    obj = obj.replace(/authLeadershipResult/g, i18n.global.t('message.authLeadershipResult'));
    obj = obj.replace(/authLeadership/g, i18n.global.t('message.authLeadership'));
    //bbs
    obj = obj.replace(/monitoringTitle/g, i18n.global.t('message.monitoringTitle'));
    obj = obj.replace(/startDate/g, i18n.global.t('message.startDate'));
    obj = obj.replace(/endDate/g, i18n.global.t('message.endDate'));
    obj = obj.replace(/periodType/g, i18n.global.t('message.periodType'));
    obj = obj.replace(/periodStartDay/g, i18n.global.t('message.periodStartDay'));
    obj = obj.replace(/periodCnt/g, i18n.global.t('message.periodCnt'));
    obj = obj.replace(/duplicateYn/g, i18n.global.t('message.duplicateYn'));
    obj = obj.replace(/timelineYn/g, i18n.global.t('message.timelineYn'));
    obj = obj.replace(/reportDay/g, i18n.global.t('message.reportDay'));
    obj = obj.replace(/reportAutoYn/g, i18n.global.t('message.reportAutoYn'));
    obj = obj.replace(/targetMember/g, i18n.global.t('message.targetMember'));
    obj = obj.replace(/auditMember/g, i18n.global.t('message.auditMember'));
    obj = obj.replace(/place/g, i18n.global.t('message.place'));
    //행동
    obj = obj.replace(/sortType/g, i18n.global.t('message.sortType'));
    obj = obj.replace(/categoryIdx/g, i18n.global.t('message.categoryIdx'));
    obj = obj.replace(/behaviorTitle/g, i18n.global.t('message.behaviorTitle'));
    obj = obj.replace(/behaviorContent/g, i18n.global.t('message.behaviorContent'));
    obj = obj.replace(/behaviorType/g, i18n.global.t('message.behaviorType'));
    obj = obj.replace(/commentCnt/g, i18n.global.t('message.commentCnt'));
    obj = obj.replace(/multiYn/g, i18n.global.t('message.multiYn'));
    obj = obj.replace(/tag/g, i18n.global.t('message.tag'));
    obj = obj.replace(/essentialYn/g, i18n.global.t('message.essentialYn'));
    obj = obj.replace(/behavior/g, i18n.global.t('message.behavior'));
    //리더십
    obj = obj.replace(/leadershipTitle/g, i18n.global.t('message.leadershipTitle'));
    obj = obj.replace(/task/g, i18n.global.t('message.task'));
    obj = obj.replace(/reportMember/g, i18n.global.t('message.reportMember'));

    obj = obj.replace(/\[insert\]/g, i18n.global.t('message.add'));
    obj = obj.replace(/\[update\]/g, i18n.global.t('message.update'));
    obj = obj.replace(/\[delete\]/g, i18n.global.t('message.delete'));
    return obj
  },
  syncLanguage(){
    //언어팩 캐시복구
    /*
    localStorage.setItem('langA', null)
    localStorage.setItem('langB', null)
    localStorage.setItem('langC', null)
    localStorage.setItem('langD', null)
    localStorage.setItem('langVersion', null)
    localStorage.setItem('companyIdx', null)
     */

    i18n.global.setLocaleMessage('A', JSON.parse(localStorage.getItem('langA')))
    i18n.global.setLocaleMessage('B', JSON.parse(localStorage.getItem('langB')))
    i18n.global.setLocaleMessage('C', JSON.parse(localStorage.getItem('langC')))
    i18n.global.setLocaleMessage('D', JSON.parse(localStorage.getItem('langD')))
    //언어팩 버전확인
    const store = useCommonStore()
    const storeRef = storeToRefs(store)
    let lang = localStorage.getItem('lang') //현재 언어
    let langCompany = localStorage.getItem('langCompany') //저장된 언어의 회사
    let langVersion = localStorage.getItem('langVersion') //저장된 언어 버전
    let companyIdx = localStorage.getItem('companyIdx')?localStorage.getItem('companyIdx'):'0' //접속한 회사
    storeRef.langList.value = JSON.parse(localStorage.getItem('langTitles'))

    LanguageService.getLanguageVersionList({companyIdx:companyIdx}).then(
      (res) => {
        let lastVersion = res.result.versions.length>0?res.result.versions[0].version:'1'
        let versionCnt = res.result.versions.length?res.result.versions.length:0
        const messageObj = i18n.global.getLocaleMessage('A')
        const messageCount = Object.keys(messageObj.message || {}).length
        utils.log(`### lastVersion:${lastVersion}, currentVersion:${langVersion}, companyIdx:${companyIdx}, messageCount:${messageCount}, lang:${lang}`)
        if(langCompany != companyIdx || lastVersion != langVersion || versionCnt==0 || messageCount <= 0){  //회사, 버전정보가 다르면 새로 가져옴
          LanguageService.getLanguageList({companyIdx:companyIdx, version:''}).then(
            (response) => {
              //제목리스트
              let titles = {items:[]}
              _.forEach(response.result.titles, (title, index)=>{
                if(!utils.isEmpty(title)) {
                  if (index == 0) titles.items.push({name: title, value: 'A'})
                  if (index == 1) titles.items.push({name: title, value: 'B'})
                  if (index == 2) titles.items.push({name: title, value: 'C'})
                  if (index == 3) titles.items.push({name: title, value: 'D'})
                }
              })
              localStorage.setItem('langTitles', JSON.stringify(titles))
              storeRef.langList.value = titles
              for(let i = 1; i <= 4; i++){
                let data = {message:{}}
                _.forEach(response.result.languages, (item)=>{
                  if(i == 1)
                    data.message[item.variable] = item.contentA;
                  else if(i == 2)
                    data.message[item.variable] = item.contentB;
                  else if(i == 3)
                    data.message[item.variable] = item.contentC;
                  else if(i == 4)
                    data.message[item.variable] = item.contentD;
                })
                if(i == 1) {
                  i18n.global.setLocaleMessage('A', data);
                  localStorage.setItem('langA', JSON.stringify(data))
                }
                else if(i == 2) {
                  i18n.global.setLocaleMessage('B', data);
                  localStorage.setItem('langB', JSON.stringify(data))
                }
                else if(i == 3) {
                  i18n.global.setLocaleMessage('C', data);
                  localStorage.setItem('langC', JSON.stringify(data))
                }
                else if(i == 4) {
                  i18n.global.setLocaleMessage('D', data);
                  localStorage.setItem('langD', JSON.stringify(data))
                }
              }

              localStorage.setItem('langVersion', response.result.versions?response.result.versions[0].version:'1')
              localStorage.setItem('langCompany', companyIdx)
              utils.log(`### lang change !! langVersion:${localStorage.getItem('langVersion')}, langCompany:${localStorage.getItem('companyIdx')}, lang:${lang}`)
              if(utils.isEmpty(lang)) {
                lang = 'A'
                localStorage.setItem('lang', lang)
                i18n.global.locale.value = lang
              }
            },
            (error) => {
              utils.log((error.response && error.response.data && error.response.data.message) || error.message || error.toString())
            }
          )
        }
      },
      (error) => {
        utils.log((error.response && error.response.data && error.response.data.message) || error.message || error.toString())
      }
    )
  }
}

export default utils;
